import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { queryKeys } from '@/constants/queryKeys'
import { ProductModel } from '@/http/models'
import { PosHttpParams } from '@/types'

import { unwrap } from '../unwrap'

/** Keeps the previous grid on screen while the next search loads, so typing never flashes an empty state. */
export const useProducts = (params: PosHttpParams.ProductList) =>
  useQuery({
    queryKey: queryKeys.products(params),
    queryFn: () => unwrap(ProductModel.getList(params)),
    placeholderData: keepPreviousData,
  })
